import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useLazyFetchProvidersQuery } from "services/providerApiSlice"
import { useLazyFetchDepartmentsQuery } from "services/commonService"
import useIsAdminRoute from "./useAdminRoute"
import { useLazyFetchDepartmentsAdminQuery } from "services/admin/departmentApiSlice"
import { useLazyGetUserDetailsQuery } from "services/apiService"
export const LoadRequireData = () => {
  const isLogin = useSelector((state) => state.user.isLogin)
  const isAdminRoute = useIsAdminRoute()
  const [fetchProviders] = useLazyFetchProvidersQuery()
  const [fetchDepartments] = useLazyFetchDepartmentsQuery()
  const [fetchDepartmentsAdmin] = useLazyFetchDepartmentsAdminQuery()
  const [fetchUserDetail] = useLazyGetUserDetailsQuery();
  const practiceid = useSelector((state) => state.user?.user?.practiceId);
  
  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken")
    if (accessToken !== "null" && !isLogin) {
      fetchUserDetail()
    }
    if (isLogin) {
      if (!isAdminRoute) fetchProviders({practiceid:practiceid}) 
        else  fetchProviders({})
      if (!isAdminRoute) fetchDepartments({practiceidlist:[practiceid]})
      else fetchDepartmentsAdmin()
    }
  }, [isLogin])
}

const useLoadRequiredData = () => {
  return LoadRequireData
}

export default useLoadRequiredData
